import E2 from './../assets/fichasTecnicas/E2.pdf'
import M3 from './../assets/fichasTecnicas/M3.pdf'
import T3 from './../assets/fichasTecnicas/T3.pdf'
import YUAN300 from './../assets/fichasTecnicas/YUAN300.pdf'
import YUAN400 from './../assets/fichasTecnicas/YUAN400.pdf'
import SONGPRO from './../assets/fichasTecnicas/SONGPRO.pdf'

const Fichas = {
    "HATCHBACK EV": E2,
    "M3": M3,
    "T3": T3,
    "YUAN 300":YUAN300,
    "YUAN 400":YUAN400,
    "SONG PRO":SONGPRO
}

export default Fichas;